<template>
    <svg 
        width="1rem"
        height="1rem" 
        viewBox="0 0 1024 1024" 
        xmlns="http://www.w3.org/2000/svg" 
        fill="#000000">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier"><path fill="#c2eae2" d="M512 640a256 256 0 1 0 0-512 256 256 0 0 0 0 512zm0 64a320 320 0 1 1 0-640 320 320 0 0 1 0 640z"></path>
            <path fill="#c2eae2" d="M512 640q32 0 32 32v256q0 32-32 32t-32-32V672q0-32 32-32z"></path>
            <path fill="#c2eae2" d="M352 800h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32z"></path>
        </g>
    </svg>
</template>